import styled from 'styled-components';

import theme from 'styles/theme';

export const Menu = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 250px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background: ${theme.B400};

  .Menu__header {
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
    padding: 35px;
  }

  .Menu__logo {
    width: 85px;
    height: auto;
    animation-duration: 0.85s;
    animation-fill-mode: both;

    &:hover {
      animation-name: rubberBand;
    }
  }

  .Menu__item {
    padding: 8px 15px;
    color: ${theme.font_secondary};
    font-size: 18px;
    text-align: center;
    transition: background 0.5s, color 0.5s;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
      box-shadow: inset 1px 1px 5px rgba(0, 0, 0, 0.2);
      color: ${theme.A500};
    }
  }

  .Menu__navigation {
    padding: 30px 0;
  }
`;

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.styles.js